import api from "../Api";
import routes from "constants/ApiRoutesConstants";

export async function PostNewUser(formData, selectSupplier) {
  const jsonData = Object.fromEntries(formData.entries());

  const supplierList = selectSupplier.map((supplier) => {
    return supplier.value;
  });

  jsonData.suppliers = supplierList;

  const res = await api.post(routes.ADMIN_CREATE_USER, jsonData);
  return res;
}

export async function PatchUserDetailsUpdate(formData) {
  const jsonData = Object.fromEntries(formData.entries());

  const res = await api.patch(routes.ADMIN_USER_MODIFY, jsonData);
  return res;
}

export async function GetResendInvitationEmail(params) {
  const res = await api.get(routes.ADMIN_RESEND_INVITATION, {
    params: params,
  });
  return res;
}
